//@ts-check

/** @typedef {import("./GameList.js").GameListType} GameListType */
/** @type {GameListType} */
let GameList;
const BRAND_NAME = process.env.BRAND_NAME;

/** @returns {Promise<GameListType>} */
async function loadGameList() {
    if (BRAND_NAME === "yalla") {
        return (await import("./GameListYalla.js")).GameList;
    } else {
        return (await import("./GameListBeeFee.js")).GameList;
    }
}


export { loadGameList };